import { render, staticRenderFns } from "./TripListItem.vue?vue&type=template&id=53944413&scoped=true&"
import script from "./TripListItem.vue?vue&type=script&lang=js&"
export * from "./TripListItem.vue?vue&type=script&lang=js&"
import style0 from "./TripListItem.vue?vue&type=style&index=0&id=53944413&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53944413",
  null
  
)

/* custom blocks */
import block0 from "./TripListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports